// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"fcca428f","8":"055578bc","346":"e86323c2","431":"dad33168","488":"c92cbdfc","838":"5972c625","874":"8882d7ea","924":"68efc0c8","977":"c7faba77"}[chunkId] + ".chunk.js";
};